<ng-template #actions>
  <div class="forms-rail-actions flex shrink-0 items-center gap-4">
    <app-panel-form-create class="min-w-0 flex-1" appearance="rail" [folderId]="store.folder()" [beforeCreate]="beforeCreateForm" (created)="createdForm($event)" />
    <app-nav-add-menu [app]="app" appearance="rail" />
  </div>
</ng-template>
<ng-template #collections>
  <app-context-menu-window>
    @if (hasSearchResults() || store.search()) { <app-context-menu-item [withCheckOption]="true" [close]="true" title="All Results" [active]="store.view() === 'search_results' && !store.foldersOpen()" (execute)="navigateCollection('search_results')" /> }
    @for (view of views; track view.id) { <app-context-menu-item [withCheckOption]="true" [close]="true" [active]="store.view() === view.id && !store.foldersOpen() && !store.folder()" [title]="view.title" (execute)="navigateCollection(view.id)" /> }
    <app-context-menu-item [withCheckOption]="true" [close]="true" [active]="store.foldersOpen() || !!store.folder()" title="Folders" (execute)="navigateCollection('folders')" />
  </app-context-menu-window>
</ng-template>
<ng-template #libraryHeader>
  <div class="border-b border-gray-200"><div class="px-8 h-20 items-center flex gap-3">
    @if (panel() && panelCanGoBack()) { <app-button2 appearance="secondary-ghost" size="s" data-test="forms-panel-back" [ariaLabel]="panelBackLabel()" [matTooltip]="panelBackLabel()" (click)="goBackInPanel()"><app-icon name="chevron-left" />@if (store.current() || store.selectedFolder()) { <span class="truncate">{{ panelBackLabel() }}</span> }</app-button2> }
    @if (panel()) {
      <app-dropdown-label stchPopover stchPopoverTrigger="click" stchPopoverPlacement="bottomLeft" [stchPopoverContent]="collections" (stchPopoverVisibleChange)="viewsMenuOpened.set($event)" [collapsed]="!viewsMenuOpened()">{{ listTitle() }}</app-dropdown-label>
    } @else {
      <div class="text-[13px] font-medium tracking-[0.3px] text-headline whitespace-nowrap overflow-hidden text-ellipsis">
        {{ listTitle() }}
      </div>
    }
    <div class="grow"></div>
    <app-context-menu-state-indicator svgIcon="filters" appFormsLibraryOptions />
    @if (panel()) {
      <app-search-state-indicator [applied]="panelSearchApplied()" (clear)="clearPanelSearch()">
        <app-icon class="max-w-8 max-h-8 text-gray-500 cursor-pointer items-center" name="search-small" stchPopover stchPopoverPlacement="bottomRight" stchPopoverTrigger="click" [stchPopoverContent]="panelSearchPopover" [stchPopoverFallbackPlacements]="[]" [stchPopoverShowUntil]="panelSearchClose" />
      </app-search-state-indicator>
    }
  </div></div>
</ng-template>
<ng-template #panelSearchPopover><app-forms-search-popover [width]="420" [beforeApply]="mayApplyPanelSearch" [apply]="applyPanelSearch" (onSearch)="panelSearchClose.next()" (onCancel)="panelSearchClose.next()" /></ng-template>
<ng-template #list let-minimized="minimized" let-showHeader="showHeader">
  @if (!minimized) {
    <div class="forms-list">
      @if (showHeader !== false) { <ng-container *ngTemplateOutlet="libraryHeader" /> }
      @if (sidebarActions.pendingLabel(); as label) { <div class="mx-8 my-4 text-sm text-subdued" role="status">{{label}} is not yet confirmed. <app-button2 appearance="secondary" size="s" [disabled]="sidebarActions.busy()" (click)="sidebarActions.retry()">Retry the same action</app-button2></div> }
      @if (pendingFolderTitle(); as title) {
        <div class="mx-8 my-4 text-sm text-subdued" role="alert">The creation of “{{ title }}” is not confirmed.
          <app-button2 appearance="secondary" size="s" [disabled]="folderCreating()" (click)="retryFolderCreation()">Retry folder creation</app-button2>
        </div>
      }
      <app-list-load-error [error]="store.error()" (retry)="store.refresh()" />
      @if (store.foldersOpen()) {
        <div class="min-h-0 flex-1 overflow-y-auto border-gray-200" [class.border-t]="panel()">
          @for (folder of folderRows(); track folder.id) {
            <app-forms-folder-library-card [folder]="folder" [canMove]="canMoveForms" (open)="openFolder(folder, $event, true)" (move)="moveToFolder($event, folder)" />
          } @empty {
            @if (!store.loading() && !store.error()) { <app-no-content-stub class="h-full" imageSrc="assets/placeholders/empty-slides.svg" [size]="75"><p class="text-base font-medium text-gray-900 text-center">{{ store.search().trim() ? 'No folders match your search' : 'No folders' }}</p></app-no-content-stub> }
          }
        </div>
      } @else {
        <div class="forms-list-body has-[app-list-items-separator]:scroll-pt-16" appSelectableList #selectable="appSelectableList" appSelectableListLabel="Forms"
          [appSelectableListReset]="resetSelected" [appSelectableListItems]="rows()" [deselectOnReclick]="panel()" (openSelected)="selected($event)">
          @if (store.loading() && !store.items().length) { <app-loading-indicator [inPanel]="true">Loading forms</app-loading-indicator> }
          @for (item of items(); track item.form.id) {
            @if (item.showSectionHeader) {
              <app-list-items-separator [value]="item.section" />
            }
            <app-forms-library-card class="block" [class.bg-background-highlight]="item.form.pinned || (item.form.flagged && store.options().flaggedOnTop)" [item]="item.form" [position]="$index"
              [appSelectable]="item.form" [appSelectablePosition]="$index" [appSelectableIdentifier]="item.form.id" [appSelectableListRef]="selectable"
              (open)="open(item.form)" (onDoubleClick)="open(item.form, !panel())" />
          } @empty {
            @if (!store.loading() && !store.error()) {
              <app-no-content-stub class="grow h-full" imageSrc="assets/forms-engine/stitch/illustrations/empty-forms.svg" [size]="75">
                <div class="flex max-w-full flex-col items-center gap-2">
                  @if (panelSearchApplied()) {
                    <p class="text-base font-medium text-gray-900 text-center">No forms match your search</p>
                  } @else if (store.view() === 'deleted') {
                    <p class="text-base font-medium text-gray-900 text-center">{{ !store.isDefaultOptions() ? NO_MATCH_TITLE : TRASH_EMPTY_TITLE }}</p>
                  } @else if (store.view() === 'archived') {
                    <p class="text-base font-medium text-gray-900 text-center">{{ !store.isDefaultOptions() ? NO_MATCH_TITLE : ARCHIVE_EMPTY_TITLE }}</p>
                  } @else {
                    <p class="text-base font-medium text-gray-900 text-center">No forms</p>
                    <p class="text-sm text-gray-600 text-center">Create a form to get started.</p>
                  }
                </div>
              </app-no-content-stub>
            }
          }
        </div>
        <app-list-selection-bar [list]="selectable" />
      }
      <app-pagination2 class="border-t border-border" [page]="pageNumber()" [pageSize]="pageSize" [totalItems]="store.foldersOpen() ? folderCount() : store.count()" [loading]="store.loading()" (refresh)="store.refresh()" (pageChange)="goToPage($event)" />
    </div>
  }
</ng-template>
<ng-template #folderContents>
  @if (store.selectedFolder(); as folder) {
    <app-forms-hub-list [filters]="folderContentsFilters()" [tenantId]="folder.accountId" [libraryInteractions]="true"
      [selectAllRequest]="folderSelectAllRequest()" (selectionApplied)="folderSelectAllRequest.set(0)"
      (itemActivate)="openFolderForm($event)" (itemOpen)="openFolderForm($event, !panel())" />
  }
</ng-template>
<ng-template #record>
  @if (store.current()) { <app-forms-record [closeRecord]="closeRecordSurface" /> }
  @else if (store.selectedFolder()) { <app-forms-folder-record [contents]="folderContents" [closeRecord]="closeRecordSurface" (formCreated)="panelParentFolder.set($event)" (selectContents)="selectFolderContents()" /> }
  @else {
    <app-no-content-stub class="w-full" imageSrc="assets/forms-engine/stitch/illustrations/empty-forms.svg" [size]="124">
      <p class="text-base font-medium text-gray-900 text-center">No form selected</p>
      <app-button2
        class="[&>button]:bg-offwhite"
        appearance="secondary"
        size="m"
        [gap]="4"
        (click)="create()"
      >
        <app-icon name="sapphire-form" />
        Create a new form
      </app-button2>
    </app-no-content-stub>
  }
</ng-template>
@if (panel()) {
  <div class="flex h-full min-h-0 flex-col">
    <ng-container *ngTemplateOutlet="libraryHeader" />
    @if (panelCreationAllowed()) { <app-panel-form-create class="block px-4 py-2" [folderId]="store.folder()" [beforeCreate]="beforeCreateForm" (created)="createdForm($event)" /> }
    @if (store.current() || store.selectedFolder()) {
      @if (store.current()) {
      <div class="flex items-center justify-between border-b border-border px-4 py-2"><app-button2 appearance="secondary-text" size="s" data-test="forms-panel-back-to-forms" (click)="panelBack()"><app-icon name="chevron-left" />Back to {{ listTitle() }}</app-button2></div>
      }
      <div class="min-h-0 flex-1"><ng-container *ngTemplateOutlet="record" /></div>
    }
    <section class="flex min-h-0 flex-1 flex-col" [class.hidden]="!!store.current() || !!store.selectedFolder()" [attr.inert]="store.current() || store.selectedFolder() ? '' : null" aria-label="Forms library">
      @if (panelFolderCreationAllowed()) {
        @if (panelFolderFormOpen()) { <app-forms-quick-form placeholder="Untitled folder" [autofocus]="true" [createFromForm]="createFolderTask" (close)="panelFolderFormOpen.set(false)" /> }
        @else { <app-quick-action-button class="block px-4 py-2" label="New folder" hint="" ariaLabel="Add New Folder" (click)="panelFolderFormOpen.set(true)" /> }
      }
      @if (store.folder() && !store.current()) {
        <app-button2 appearance="secondary-text" size="s" (click)="navigateCollection('folders')"><app-icon name="chevron-left" />Back to folders</app-button2>
      }
      <ng-container *ngTemplateOutlet="list; context: { showHeader: false }" />
    </section>
  </div>
} @else {
  <div class="forms-shell">
    <app-collapsible-rail-shell class="forms-rail" [app]="app" [actionsTemplate]="actions" [temporaryParked]="railFolded()" (temporaryUnparked)="fullWindow.reopenRail()">
      @if (hasSearchResults()) { <app-sidebar-item class="rounded hover:bg-hover" title="All Results" icon="sapphire-search" [minimized]="minimized()" [active]="store.view() === 'search_results' && !store.folder() && !store.foldersOpen()" (appClick)="store.landOnSearchResults()" /> }
      @for (view of views; track view.id) {
        <app-sidebar-item class="rounded [&:not(.drag-over)]:hover:bg-hover" [title]="view.title" [icon]="view.icon" [minimized]="minimized()"
          [attr.aria-label]="view.title" role="button" tabindex="0"
          (keydown.enter)="store.selectView(view.id)" (keydown.space)="$event.preventDefault(); store.selectView(view.id)"
          [appFormsSidebarContextMenu]="view.id" (appFormsSidebarContextMenuFormCreated)="open($event,true)" (appFormsSidebarContextMenuFolderCreated)="openFolder($event)"
          [badge]="view.id === 'all' ? { template: allCount, context: { count: store.allCount() } } : undefined"
          [active]="store.view() === view.id && !store.folder() && !store.foldersOpen()" (appClick)="store.selectView(view.id)"
          appDroppable appDroppableHoverClass="drag-over" [appDroppablePredicate]="canMoveForms" (appDroppableDrop)="dropOnView($event, view.id)" />
      }
      <app-sidebar-items-divider />
      <div stchPopover [stchPopoverArrow]="true" [stchPopoverContent]="foldersPopoverTemplate" [stchPopoverInnerShadow]="true" stchPopoverPlacement="right" [stchPopoverDisabled]="!minimized()" stchPopoverTrigger="click">
        <app-sidebar-item title="Folders" icon="sapphire-folders" [expandable]="true" [expanded]="foldersExpanded()" [minimized]="minimized()" [active]="store.foldersOpen()"
          appFormsSidebarContextMenu="folders" (appFormsSidebarContextMenuFolderCreated)="openFolder($event)"
          [actions]="[{ icon: 'sapphire-plus', tooltip: 'New folder', template: folderQuickForm, until: folderQuickClose, appearance: 'dialog' }]"
          (onExpand)="setFoldersExpanded($event)" (appClick)="store.showFolders()">
          <app-context-menu-state-indicator appearance="sapphire" svgIcon="sapphire-ellipsis" appFormsLibraryOptions />
        </app-sidebar-item>
      </div>
      @if (!minimized()) {
        <div class="overflow-hidden" [@heightAnimation]="foldersExpanded() ? 'show' : 'hide'">
          <ng-container *ngTemplateOutlet="foldersListTemplate" />
        </div>
      }
      <app-sidebar-items-divider />
      <app-knowledge-items-rail [sidebarSplitViewKey]="SidebarSplitViewKey.forms" />
    </app-collapsible-rail-shell>
    <div class="forms-rest">
      @if (store.current() && store.editor()) {
        <app-split-view side="left" key="formsEditorList" [collapsedSize]="25" [shadow]="true" [magneticSize]="300" [withIcon]="true" [iconTop]="38"
          [temporaryCollapsed]="!editorListOpen()" (temporaryOpened)="editorListOpen.set(true)">
          <div split-left-pane class="list shadow-lg"><ng-container *ngTemplateOutlet="list; context: { minimized: editorListMinimized() }" /></div>
          <div split-right-pane class="block h-full shadow-lg"><ng-container *ngTemplateOutlet="record" /></div>
        </app-split-view>
      } @else {
        <app-split-view side="left" key="formsList" [collapsedSize]="25" [shadow]="true" [magneticSize]="300" [withIcon]="true" [iconTop]="38"
          [temporaryCollapsed]="listFolded()" (temporaryOpened)="listFolded.set(false)">
          <div split-left-pane class="list shadow-lg"><ng-container *ngTemplateOutlet="list; context: { minimized: listMinimized() }" /></div>
          <div split-right-pane class="full-form shadow-lg"><ng-container *ngTemplateOutlet="record" /></div>
        </app-split-view>
      }
    </div>
  </div>
}
<ng-template #allCount let-count="count"><span class="text-xs text-subdued" data-testid="all-forms-count">{{ count }}</span></ng-template>
<ng-template #folderQuickForm><div class="box-border w-[var(--quick-form-dialog-width-rail)]"><app-forms-quick-form placeholder="Untitled folder" [autofocus]="true" [createFromForm]="createFolderTask" (close)="folderQuickClose.next()" /></div></ng-template>
<ng-template #foldersPopoverTemplate>
  @if (minimized()) {
    <div class="m-4 h-[216px] w-[200px] overflow-auto">
      <ng-container *ngTemplateOutlet="foldersListTemplate" />
    </div>
  }
</ng-template>
<ng-template #foldersListTemplate>
  @if (visibleFolders().length === 0) {
    <span class="text-subdued px-8 py-2 text-sm">No folders found</span>
  }
  @for (folder of visibleFolders(); track folder.id) {
    <app-sidebar-item class="rounded [&:not(.drag-over)]:hover:bg-hover" [title]="folder.title" iconSlot="none"
      [active]="store.folder() === folder.id"
      [badge]="{ template: badgeTemplate, context: { pinned: folder.pinned, flagged: folder.flagged } }"
      (appClick)="openFolder(folder)" [appFormFolderContextMenu]="folder" (appFormFolderContextMenuOpen)="openFolder(folder, $event)"
      appDroppable appDroppableHoverClass="drag-over" [appDroppablePredicate]="canMoveForms" (appDroppableDrop)="moveToFolder($event, folder)" />
  }
</ng-template>
<ng-template #badgeTemplate let-pinned="pinned" let-flagged="flagged">
  <div class="flex h-full flex-col items-center justify-center">
    @if (pinned) {
      <app-icon class="text-primary" size="xs" name="sapphire-pin-filled" />
    }
    @if (flagged) {
      <app-icon class="text-orange-500" size="xs" name="sapphire-flagged-filled" />
    }
  </div>
</ng-template>
